import { render, staticRenderFns } from "./SavePanel.vue?vue&type=template&id=4889957e&scoped=true&lang=pug"
import script from "./SavePanel.vue?vue&type=script&lang=js"
export * from "./SavePanel.vue?vue&type=script&lang=js"
import style0 from "./SavePanel.vue?vue&type=style&index=0&id=4889957e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4889957e",
  null
  
)

export default component.exports